import React, { useState } from 'react';

import './SelectDocument.css';

import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';
import { IMitekFlowComponentProps } from '../MitekFlow';
import { Button, Row, Col, Image, Container } from '../../../importCL';
import { InputRadio } from 'component-library/index';

export interface IRadioButtonItem {
    labelText?: string,
    idValueData?: string,
    radioButtonRedirect?: string
}
export interface ISelectDocumentProps extends IMitekFlowComponentProps {
    radioButtonListItems ?: IRadioButtonItem[];
}

const SelectDocument = (props: ISelectDocumentProps) : JSX.Element => {

    const [ radioSelection, setRadioSelection ] = useState('');

    const handleOnClick = () => {
        if (props.radioButtonListItems) {
            for (const radio of props.radioButtonListItems) {
                if (radio.idValueData!.includes(radioSelection)) {
                    props.setFlowStage(radioSelection);
                }
            }
        }
    };

    return (
        <Container id='mitek-select-id' className='MitekFlowSelectId MitekSelectId__container'>
            {props.imgPath && 
            <Row>
                <Col>
                    <Image 
                        loading='lazy'
                        className='MitekSelectId__radioButtonImage'
                        src={props.imgPath}
                        alt={props.imgAltText}
                    />
                </Col>
            </Row>
            }
            {props.description &&
            <Row>
                <Col>
                    <div className='MitekSelectId__radioButtonDescription'>
                        {transformHTMLParserLinks(props.description)}
                    </div>
                </Col>
            </Row>
            }
            {props.radioButtonListItems &&
            <Row>
                <Col>
                    <div className='MitekSelectId__radioButtonOptions'>
                        {props.radioButtonListItems.map((element, index) => {
                            return (<InputRadio 
                                className='MitekSelectId__radioButton'
                                label={element.labelText}
                                id={'MitekSelectId__radio--' + index}
                                name='MitekSelectId__radioGroup'
                                key={'key-' + index}
                                value={element.idValueData!}
                                checked={element.idValueData === radioSelection}
                                setValue={setRadioSelection}
                            />);
                        })
                        }
                    </div>
                </Col>
            </Row>
            }
            <Row>
                <Col>
                    <Button 
                        className='MitekSelectId__ctaButton' 
                        onClick={handleOnClick} 
                        size='medium'>
                        {props.ctaButtonText}
                    </Button>
                </Col>
            </Row>
        </Container>);
};

export default SelectDocument;